import React, { useState, useEffect, useCallback } from 'react';
import Control from '../Control/Control';
import axios from 'axios';
import util from 'util';

//アンケート入力画面
const InputEntry = ({ siteId, mallId, shopCode, liffAccessToken, customerId, entrytypeMaster, changeOrder, stampcardId, questionnaireId, order, ticketClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [loading, setLoading] = useState(false);
  const [point, setPoint] = useState(false);
  const [getPoint, setGetPoint] = useState(false);
  const [ticket, setTicket] = useState(false);

  //バックエンドサーバから会員に関する情報を取得
  const refreshData = useCallback(async () => {
    try {
      const questionnaire = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/questionnaire/line/${siteId}/${questionnaireId}/`, { customer_id: customerId, line_id: liffAccessToken, mall_id: mallId })).data;
      const questionnaireEntryTypes = [
        questionnaire.entry_type_1,
        questionnaire.entry_type_2,
        questionnaire.entry_type_3,
        questionnaire.entry_type_4,
        questionnaire.entry_type_5,
        questionnaire.entry_type_6,
        questionnaire.entry_type_7,
        questionnaire.entry_type_8,
        questionnaire.entry_type_9,
        questionnaire.entry_type_10,
      ].filter(Boolean);
      const filteredEntryTypes = entrytypeMaster.filter(x => x.m_entry_data !== null && questionnaireEntryTypes.includes(x.entry_type));
      setQuestionnaire(filteredEntryTypes);
    } catch (err) {
      console.log(err);
    }
  }, [siteId, questionnaireId, customerId, liffAccessToken, mallId, entrytypeMaster]);

  const submitStampCard = useCallback(async (stampcard_id, questionnaire_id) => {

    if (!window.confirm('特典を受け取ります、よろしいですか？')) {
      return;
    }
    try {
      setLoading(true);
      var entry_data = {};
      questionnaire.filter(data => (data.m_entry_data.length === 0 || data.m_entry_data[0].input_type !== "label")).map((data, idx) => (
        data.m_entry_data.forEach((entryData, entryDataIdx) => {
          entry_data[entryData.param_name] = order[entryData.param_name];
        })
      ));
      const params = {
        site_id: siteId,
        line_id: liffAccessToken,
        mall_id: mallId,
        stampcard_id,
        questionnaire_id,
        entry_data
      };

      var result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/stamp/line/use`, params);
      if (result.data.stampcard) {
        if (result.data.point && result.data.ticket) {
          window.alert('受け取りました。');
          await refreshData();
          setPoint(true);
          setGetPoint(result.data.getpoint);
          setTicket(true);
        } else if (result.data.point && result.data.getpoint) {
          window.alert('受け取りました。');
          await refreshData();
          setPoint(true);
          setGetPoint(result.data.getpoint);
        }
        else if (result.data.ticket) {
          window.alert('受け取りました。');
          await refreshData();
          setTicket(true);
        }
      } else {
        if (result.data.message) {
          window.alert(result.data.message);
        } else {
          window.alert("エラーが発生しました。");
        }
        setLoading(false);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        // console.log(util.inspect(err));
        window.alert(err.response.data.message);
      } else {
        console.log(util.inspect(err));
        window.alert("エラーが発生しました。");
      }
      setLoading(false);
    }
  }, [siteId, mallId, liffAccessToken, refreshData, order, questionnaire]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  return (
    <React.Fragment>
      {(!point && !ticket) &&
        <div className='col rounded bg-lightwhite'>
          <div className={`row rounded-top title-bgcolor py-2 position-relative`}>
            <div className='col-2 m-0 p-0 pl-2 align-self-center text-left position-absolute start-0'>
              <img src={`/${siteId}/images/plan_entry_icon.png`} style={{ width: "2rem" }} alt="icon" onError={(event) => event.target.style.display = 'none'} />
            </div>
          </div>
          {questionnaire[currentIndex] && questionnaire[currentIndex].m_entry_data && (
            <React.Fragment>
              {(questionnaire[currentIndex].m_entry_data !== null && questionnaire[currentIndex].m_entry_data.length > 0 && questionnaire[currentIndex].m_entry_data[0].input_type !== "label") &&
                <div className="row mx-0 my-3 text-center">
                  <div className='col-12 m-0 p-0 text-left'>{questionnaire[currentIndex].required ? <span className='text-required'>[必須]</span> : <span className='text-optional'>[任意]</span>}</div>
                  <div className="col px-0 text-left">
                    <span className='font-weight-bold'>{questionnaire[currentIndex].entry_type_name}</span>
                  </div>
                  {(questionnaire[currentIndex].m_entry_data !== null && questionnaire[currentIndex].m_entry_data[0].input_type === "check") && <div className='col-12 m-0 p-0 text-left h6'>(複数選択可)</div>}
                </div>
              }
              <div className="row my-2">
                {questionnaire[currentIndex].remarks && <label className={`w-100 ml-1 h6`}>{questionnaire[currentIndex].remarks}</label>}
                {questionnaire[currentIndex].m_entry_data.map((entryData, entryDataIdx) => (
                  <Control
                    target={"sp"}
                    siteId={siteId}
                    setState={(name, value) => { changeOrder({ target: { type: "text", name, value: value } }); }}
                    m_entry_data={questionnaire[currentIndex].m_entry_data}
                    entryData={entryData}
                    entryDataIdx={entryDataIdx}
                    key={entryDataIdx}
                    value={order[entryData.param_name]}
                  />
                ))}
              </div>
              <div className="row my-3">
                <div className="col text-right">
                  {currentIndex < questionnaire.length - 1 ? (
                    <button disabled={
                      questionnaire[currentIndex].required &&
                      questionnaire[currentIndex].m_entry_data.every(
                        entryData => !order[entryData.param_name] || order[entryData.param_name].length === 0
                      )
                    } className="button" onClick={() => setCurrentIndex(currentIndex + 1)}>
                      次へ
                    </button>
                  ) : (
                    <button disabled={
                      loading ||
                      (questionnaire[currentIndex].required &&
                        questionnaire[currentIndex].m_entry_data.every(
                          entryData => !order[entryData.param_name] || order[entryData.param_name].length === 0
                        ))
                    } className="button" onClick={() => submitStampCard(stampcardId, questionnaireId)}>
                      特典を受け取る
                    </button>
                  )}
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      }
      {(point || ticket) &&
        <div className="applottery-container">
          <div className="frame50">
            {point && ticket ?
              <img src={`/${siteId}/getpointticket.svg`} alt='getpointticket' className='w-100' />
              : point ?
                <img src={`/${siteId}/getpoint.svg`} alt='getpoint' className='w-100' />
                : ticket ?
                  <img src={`/${siteId}/getticket.svg`} alt='getticket' className='w-100' />
                  : null
            }
            {point && ticket &&
              <div className="applotterypointcouponframe49">
                <div className="frame11">
                  <div className="points-held">
                    獲得ポイント
                  </div>
                  <div className="lottery-frame9">
                    <div className="lottery-points">
                      {getPoint}
                    </div>
                  </div>
                  <div className="applottery-text3">
                    おめでとうございます！<br />
                    ポイントとクーポンを<br />
                    ゲットしました。
                  </div>
                  <button
                    onClick={() => ticketClick()}
                    className="button mt-3 text-black bg-white">
                    クーポンを表示する
                  </button>
                </div>
              </div>
            }
            {point && !ticket &&
              <div className="applotterypointframe49">
                <div className="frame11">
                  <div className="points-held">
                    獲得ポイント
                  </div>
                  <div className="lottery-frame9">
                    <div className="lottery-points">
                      {getPoint}
                    </div>
                  </div>
                  <div className="applottery-text3">
                    おめでとうございます！<br />
                    ポイントをゲットしました。
                  </div>
                </div>
              </div>
            }
            {ticket && !point &&
              <div className="applotterypointframe49">
                <div className="frame11">
                  <div className="applottery-text3 my-2">
                    おめでとうございます！<br />
                    クーポンをゲットしました。
                  </div>
                  <button
                    onClick={() => ticketClick()}
                    className="button mt-3 text-black bg-white">
                    クーポンを表示する
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </React.Fragment>
  );
}

export default InputEntry;